function mobileNav() {
  if (window.innerWidth <= 991) {
    const menuItems = document.querySelectorAll('#main-menu > li.nav-item.dropdown > a');
    menuItems.forEach((item) => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        this.parentNode.classList.toggle('active');
        let siblings = Array.from(this.parentNode.parentNode.children);
          siblings.splice(siblings.indexOf(this.parentNode), 1); // remove clicked item from sibling list
          siblings.forEach((sibling) => {
            sibling.classList.remove('active');
            sibling.classList.toggle('not-active');
          });
      });
    });
  }

  if (window.innerWidth <= 991) {
    const menuItems = document.querySelectorAll('#footer-menu > li.menu-item-has-children > a');
    menuItems.forEach((item) => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        this.parentNode.classList.toggle('active');
        let siblings = Array.from(this.parentNode.parentNode.children);
          siblings.splice(siblings.indexOf(this.parentNode), 1); // remove clicked item from sibling list
          siblings.forEach((sibling) => 
            sibling.classList.remove('active')
          );
      });
    });
  }

  if (window.innerWidth <= 991) {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const mainMenu = document.querySelector('#main-menu');

    navbarToggler.addEventListener('click', function() {
      const menuItems = Array.from(mainMenu.children);

      // Remove 'active' and 'not-active' classes from each menu item
      menuItems.forEach((item) => {
        item.classList.remove('active', 'not-active');
      });
    });
  } else {
    const mainMenu = document.querySelector('#main-menu');
    const menuItems = Array.from(mainMenu.children);
    menuItems.forEach((item) => {
      item.classList.remove('active', 'not-active');
    });
  }
}

window.addEventListener('resize', mobileNav);

mobileNav();

const dropdownMenus = document.querySelectorAll('div.dropdown-menu.nav-item-dropdown-container, div.dropdown-menu.search-dropdown-container');

dropdownMenus.forEach(function(dropdownMenu) {
  dropdownMenu.addEventListener('click', function(event) {
    event.stopPropagation();
  });
});

const privacyPolicyLinks = document.querySelectorAll('.privacy-policy a');
privacyPolicyLinks.forEach(link => {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    this.classList.toggle('active');
  });
});


function mktoPostLoad(formId) {
  console.log('post load function hit')
  const mktoButtonLinks = document.querySelectorAll('.mktoButton');
  if(mktoButtonLinks!==null) {
    mktoButtonLinks.forEach(link => {
      link.setAttribute('id', 'mktoButton');
    });
  }

  const requiredText = document.createElement('p');
  requiredText.classList.add('required');
  requiredText.textContent = 'All fields required';
  
  const targetElement = document.querySelector('.mktoButtonRow');
  if(targetElement!==null) {
    targetElement.appendChild(requiredText);
  }
}

// Initialize tooltips
document.addEventListener('DOMContentLoaded', function () {
  var tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipElements.forEach(function(element) {
      new bootstrap.Tooltip(element);
  });
});

// Accordion handler
document.addEventListener('DOMContentLoaded', function () {
  var allPanels = document.querySelectorAll('.accordion__container dd');
  var allHeaders = document.querySelectorAll('.accordion__container .accordion__topic > a');

  // Hide all panels initially
  allPanels.forEach(function(panel) {
      panel.style.display = 'none';
  });

  // Add click event listener to all headers
  allHeaders.forEach(function(header) {
      header.addEventListener('click', function (e) {
          e.preventDefault();
          var current = this;
          var target = current.closest('dt').nextElementSibling;

          if (!target.classList.contains('active')) {
              allPanels.forEach(function(panel) {
                  panel.classList.remove('active');
                  panel.style.display = 'none';
              });
              allHeaders.forEach(function(hdr) {
                  hdr.classList.remove('open');
                  hdr.classList.add('closed');
              });
              current.classList.add('open');
              current.classList.remove('closed');
              target.classList.add('active');
              target.style.display = 'block';
          } else {
              allPanels.forEach(function(panel) {
                  panel.classList.remove('active');
                  panel.style.display = 'none';
              });
              allHeaders.forEach(function(hdr) {
                  hdr.classList.remove('open');
                  hdr.classList.add('closed');
              });
          }
      });
  });
});

  
// Event Cards - Bootstrap Collapse Toggle

document.querySelectorAll('.card-events__card [data-bs-toggle="collapse"]').forEach(function(el) {
  el.addEventListener('click', function() {
    this.classList.toggle('active');
    const svg = this.querySelector('svg');
    const path = svg.querySelector('path:first-of-type');
    if (path.getAttribute('display') === 'none') {
      path.setAttribute('display', 'inline');
    } else {
      path.setAttribute('display', 'none');
    }
    
    let text = this.textContent.trim();
    
    if (this.classList.contains('active')) {
      text = text.replace(/^Show/, 'Hide');
    } else {
      text = text.replace(/^Hide/, 'Show');
    }
    
    this.innerHTML = '';
    this.appendChild(svg);
    this.appendChild(document.createTextNode(text));
  });
});